import { atom, useAtomValue } from 'jotai'
import {
  errors$ as errorsCancelGuard$,
  isInputCompleted$ as isInputCompletedCancelGuard$,
} from '../store/cancelGuard'
import { selectedCardStatus$ } from '../store/card'
import { submitCardDisabled } from '../store/lib/checkDisabled'
import { plan$ } from '../store/stateMachine/state'
import {
  errors$ as errorsCardPayment$,
  isInputCompleted$ as isInputCompletedCardPayment$,
} from './card-payment'
import { scope } from './scope'

type Submitted = 'initial' | 'pending' | 'finished'

/** カードふすまで「決定」ボタンを押した時の処理状態 */
export const submitted$ = scope.atom<Submitted>('initial', 'submitted$')

export function useSubmitted() {
  return useAtomValue(submitted$)
}

/** カードふすまで「決定」ボタンを押した時のトークン生成エラー */
export const tokenError$ = scope.atom<string | undefined>(undefined, 'tokenError$')

export function useTokenError() {
  return useAtomValue(tokenError$)
}

/** カードふすまの「決定」ボタンの disabled 状態 */
const submitCardButtonDisabled$ = atom((get) => {
  const isInputCompleted = get(plan$)?.isCancelGuard
    ? get(isInputCompletedCancelGuard$)
    : get(isInputCompletedCardPayment$)
  const errors = get(plan$)?.isCancelGuard ? get(errorsCancelGuard$) : get(errorsCardPayment$)
  return (
    submitCardDisabled(isInputCompleted, errors, get(selectedCardStatus$)) ||
    get(submitted$) === 'pending'
  )
})
submitCardButtonDisabled$.debugLabel = 'submitCardButtonDisabled$'

export function useSubmitCardButtonDisabled() {
  return useAtomValue(submitCardButtonDisabled$)
}
